"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_http_1 = require("@comunica/bus-http");
/**
 * A comunica Proxy Http Actor.
 */


var ActorHttpProxy =
/*#__PURE__*/
function (_bus_http_1$ActorHttp) {
  _inherits(ActorHttpProxy, _bus_http_1$ActorHttp);

  function ActorHttpProxy(args) {
    _classCallCheck(this, ActorHttpProxy);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorHttpProxy).call(this, args));
  }

  _createClass(ActorHttpProxy, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        var proxyHandler;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                proxyHandler = action.context.get(exports.KEY_CONTEXT_HTTPPROXYHANDLER);

                if (proxyHandler) {
                  _context.next = 3;
                  break;
                }

                throw new Error("Actor ".concat(this.name, " could not find a proxy handler in the context."));

              case 3:
                _context.next = 5;
                return proxyHandler.getProxy(action);

              case 5:
                if (_context.sent) {
                  _context.next = 7;
                  break;
                }

                throw new Error("Actor ".concat(this.name, " could not determine a proxy for the given request."));

              case 7:
                return _context.abrupt("return", {
                  time: Infinity
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        var requestedUrl, proxyHandler, output;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                requestedUrl = typeof action.input === 'string' ? action.input : action.input.url;
                proxyHandler = action.context.get(exports.KEY_CONTEXT_HTTPPROXYHANDLER); // Send a request for the modified request

                _context2.t0 = this.mediatorHttp;
                _context2.t1 = Object;
                _context2.t2 = {};
                _context2.next = 7;
                return proxyHandler.getProxy(action);

              case 7:
                _context2.t3 = _context2.sent;
                _context2.t4 = {
                  context: action.context.delete(exports.KEY_CONTEXT_HTTPPROXYHANDLER)
                };
                _context2.t5 = _context2.t1.assign.call(_context2.t1, _context2.t2, _context2.t3, _context2.t4);
                _context2.next = 12;
                return _context2.t0.mediate.call(_context2.t0, _context2.t5);

              case 12:
                output = _context2.sent;
                // Modify the response URL
                output.url = output.headers.get('x-final-url') || requestedUrl;
                return _context2.abrupt("return", output);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }]);

  return ActorHttpProxy;
}(bus_http_1.ActorHttp);

exports.ActorHttpProxy = ActorHttpProxy;
exports.KEY_CONTEXT_HTTPPROXYHANDLER = '@comunica/actor-http-proxy:httpProxyHandler';